module.exports = __webpack_public_path__ + "img/licens-card-img.9dacdefc.png";